import React, { Component } from 'react';
import { DojoRepository } from '../data/DojoRepository';

export class Contacts extends Component {
    render() {
        return (
        <div class="container page-content">
            <div class="page-header">
                <h2>Contacts</h2> 
            </div>
            <hr class="hrNeonBlue" />
            <p class="lead">Pour toute question d'ordre administrative ou pour joindre votre dojo à la famille Québec ISKF, vous pouvez nous contacter aux coordonnées ci-dessous.</p>
            <article>
                <h1>Siège social</h1>
                <p>
                    <strong>Québec ISKF Honbu</strong><br />
                    265 Ouest, Boul. René-Lévesque<br />
                    Québec, Qc<br />
                    G1R 2A7
                </p>
                <p>
                    <strong>{DojoRepository.QUEBEC.contact.denis.fullName}</strong><br />
                    {DojoRepository.QUEBEC.contact.denis.phone1}<br />
                    <span class="link-like">{DojoRepository.QUEBEC.contact.denis.email2}</span>
                </p>
            </article>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/pages/contacts/Contacts.js